export enum Permissions {
    EntryView = "EntryView",
    EntryEdit = "EntryEdit",
    LocationView = "LocationView",
    LocationEdit = "LocationEdit",
    EquipmentView = "EquipmentView",
    EquipmentEdit = "EquipmentEdit",
    WorkerView = "WorkerView",
    WorkerEdit = "WorkerEdit",
    ProjectView = "ProjectView",
    ProjectEdit = "ProjectEdit",
    ContractView = "ContractView",
    ContractEdit = "ContractEdit",
    CompanyView = "CompanyView",
    CompanyEdit = "CompanyEdit",
    UserView = "UserView",
    UserEdit = "UserEdit",
    ReportView = "ReportView", //Internal report
    PersonalAlertView = "PersonalAlertView",
    MonthlyReportView = "MonthlyReportView", //For official report
}